import "../../EasyProjectsCommon/MessageManager";
import {getResxWithBrandName} from "../../common/branding";
import { commonResx } from "../../resxDist/commonResx";
import { reloadLocation } from "../../utils/urlUtils";

(function ($, ep) {
    "use strict";

    var ErrorManager = function() {
        this.handleObjectNotFoundError = function (args) {
            let dialogOnCloseCallback = args.dialogOnCloseCallback;

            args = this._adjustArgs(args);
            let message = this.getObjectNotFoundErrorMsg(args);

            let handleError = true;
            if (this._isPreset(args.entityName)) {
                handleError = false;
            }

            //show error with a little delay to allow other subscribers start to reload data.
            setTimeout(function () {
                ep.messageManager.showError(ep.resources.commonClient.OperationError_Title, message, dialogOnCloseCallback);
            }, 100);

            return handleError;
        };

        this.getObjectNotFoundErrorMsg = function (args) {
            args = this._adjustArgs(args);

            if (this._isPreset(args.entityName)) {
                return ep.resources.activityList.Error_PresetNotFound;
            }

            var entityName = ep.resources.commonClient["Entity_" + args.entityName] || args.entityName;
            var objectKey = args.objectKey;

            var messageTemplate = getResxWithBrandName(ep.resources.commonClient.Error_CantFindObjectTemplate);

            var message = messageTemplate.replace("{entityName}", entityName)
                .replace("{objectKey}", objectKey);

            return message;
        };

        this.handleUserFriendlyError = function (message, dialogOnCloseCallback, okBtnText) {
            ep.messageManager.showError(ep.resources.commonClient.OperationError_Title, message, dialogOnCloseCallback, okBtnText);
        };

        this.handleRedirectResult = function () {
            this._showReloadDialog(ep.resources.common.UnknownErrorMessage, ep.appRoot);
        };

        this.handleUnknownError = function () {
            this._showReloadDialog(commonResx.UnknownErrorMessage);
        };

        this.handleTimeoutError = function () {
            this._showReloadDialog(commonResx.TimeoutErrorMessage);
        };

        this._adjustArgs = function(args) {
            if (!args.entityName && args.EntityName) {
                args = {
                    entityName: args.EntityName,
                    objectKey: args.ObjectKey,
                };
            }
            return args;
        };

        this._isPreset = function(entityName){
            return entityName === "Preset";
        };

        this._showReloadDialog = function(message, url) {
            let resx = ep.resources.commonClient;
            ep.messageManager.showError(resx.title_reload, message, () => reloadLocation(url), resx.btn_reload);
        };

        this.handleServerVersionError = function () {
            this._showReloadDialog(getResxWithBrandName(ep.resources.common.error_reload));
        };
    };
    ep.errorManager = new ErrorManager();
})(jQuery, ep);
